
/**
 * 職人マスタページ
 * 職人情報の登録・編集・管理（Admin専用）
 */

import React from 'react'
import { useCraftsmen } from '@/features/masters/hooks/useCraftsmen'
import { CraftsmanUpdate } from '@/features/masters/types'
import CraftsmenTable from '@/features/masters/components/CraftsmenTable'
import { AddCraftsmanButton } from '@/features/masters/components/AddCraftsmanButton'
import { Skeleton } from "@/shared/ui/skeleton"
import { PageLayout, AdminPageWrapper } from '@/shared/components'
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from '@/shared/ui/breadcrumb'
import { Link } from 'react-router-dom'

/**
 * 職人マスタページコンポーネント
 */
export default function CraftsmenPage() {
    return (
        <AdminPageWrapper>
            <CraftsmenPageContent />
        </AdminPageWrapper>
    )
}

/**
 * 職人マスタページコンテンツ
 */
function CraftsmenPageContent() {
    const { data: craftsmen, isLoading, error, updateEntity, deleteEntity } = useCraftsmen()

    const handleUpdateCraftsman = async (id: string, data: CraftsmanUpdate) => {
        const result = await updateEntity(id, data)
        return !!result
    }

    const handleDeleteCraftsman = async (id: string) => {
        return await deleteEntity(id)
    }

    if (isLoading) {
        return (
            <PageLayout
                title="職人マスタ"
                description="職人情報の登録・編集を行います。"
                actions={<Skeleton className="h-10 w-28" />}
            >
                <Breadcrumb className="mb-6">
                    <BreadcrumbList>
                        <BreadcrumbItem>
                            <BreadcrumbLink asChild>
                                <Link to="/">ホーム</Link>
                            </BreadcrumbLink>
                        </BreadcrumbItem>
                        <BreadcrumbSeparator />
                        <BreadcrumbItem>
                            <BreadcrumbLink asChild>
                                <Link to="/masters">マスタ管理</Link>
                            </BreadcrumbLink>
                        </BreadcrumbItem>
                        <BreadcrumbSeparator />
                        <BreadcrumbItem>
                            <BreadcrumbPage>職人マスタ</BreadcrumbPage>
                        </BreadcrumbItem>
                    </BreadcrumbList>
                </Breadcrumb>
                <Skeleton className="h-[300px] w-full" />
            </PageLayout>
        )
    }

    if (error) {
        return (
            <PageLayout
                title="職人マスタ"
                description="職人情報の登録・編集を行います。"
            >
                <Breadcrumb className="mb-6">
                    <BreadcrumbList>
                        <BreadcrumbItem>
                            <BreadcrumbLink asChild>
                                <Link to="/">ホーム</Link>
                            </BreadcrumbLink>
                        </BreadcrumbItem>
                        <BreadcrumbSeparator />
                        <BreadcrumbItem>
                            <BreadcrumbLink asChild>
                                <Link to="/masters">マスタ管理</Link>
                            </BreadcrumbLink>
                        </BreadcrumbItem>
                        <BreadcrumbSeparator />
                        <BreadcrumbItem>
                            <BreadcrumbPage>職人マスタ</BreadcrumbPage>
                        </BreadcrumbItem>
                    </BreadcrumbList>
                </Breadcrumb>
                <div className="text-red-600">
                    <p>データの読み込み中にエラーが発生しました: {String(error)}</p>
                </div>
            </PageLayout>
        )
    }

    return (
        <PageLayout
            title="職人マスタ"
            description="職人情報の登録・編集を行います。"
            actions={<AddCraftsmanButton />}
        >
            <Breadcrumb className="mb-6">
                <BreadcrumbList>
                    <BreadcrumbItem>
                        <BreadcrumbLink asChild>
                            <Link to="/">ホーム</Link>
                        </BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbSeparator />
                    <BreadcrumbItem>
                        <BreadcrumbLink asChild>
                            <Link to="/masters">マスタ管理</Link>
                        </BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbSeparator />
                    <BreadcrumbItem>
                        <BreadcrumbPage>職人マスタ</BreadcrumbPage>
                    </BreadcrumbItem>
                </BreadcrumbList>
            </Breadcrumb>
            <CraftsmenTable
                data={craftsmen || []}
                isLoading={isLoading}
                onEdit={handleUpdateCraftsman}
                onDelete={handleDeleteCraftsman}
            />
        </PageLayout>
    )
} 